<template>
  <div class="form-container">
    <div class="form-row">
      <md-field>
        <label>Freeradius IP address</label>
        <md-input v-model="node.ip" />
        <div
          v-if="$v.node.ip.$error"
          class="error-feedback"
        >
          Field is required
        </div>
      </md-field>

      <md-field>
        <label>Port</label>
        <md-input
          v-model="node.port"
          type="number"
        />
        <div
          v-if="$v.node.port.$error"
          class="error-feedback"
        >
          Field is required
        </div>
      </md-field>
    </div>

    <div class="form-row">
      <md-field>
        <label>Node Server Address</label>
        <md-input v-model="node.server_address" />
        <div
          v-if="$v.node.server_address.$error"
          class="error-feedback"
        >
          Field is required
        </div>
      </md-field>

      <md-field>
        <label>Node Capacity</label>
        <md-input
          v-model="node.capacity"
          type="number"
        />
      </md-field>
    </div>

    <div class="form-row">
      <md-field>
        <label>Secret</label>
        <md-input
          id="secret"
          v-model="node.secret"
          :value="node.secret"
        />
        <md-icon
          class="gen-key"
          @click.native="generateSecret()"
        >
          vpn_key
        </md-icon>
        <md-icon
          v-clipboard:copy="node.secret"
          class="gen-key"
        >
          assignment
        </md-icon>
      </md-field>

      <md-field>
        <label>OS</label>
        <md-input v-model="node.os" />
      </md-field>
    </div>

    <md-field>
      <label>Pre-shared secret</label>
      <md-input
        id="pre-shared-secret"
        v-model="node.preshared_secret"
        :value="node.preshared_secret"
      />
    </md-field>

    <md-field>
      <label>Comment</label>
      <md-textarea v-model="node.comment" />
    </md-field>

    <div class="form-row">
      <md-switch v-model="node.is_enabled">
        Enabled
      </md-switch>

      <md-field>
        <label>Load Index</label>
        <md-input
          v-model="node.load_index"
          type="number"
          disabled
        />
      </md-field>
    </div>
  </div>
</template>

<script>
    import {required} from "vuelidate/lib/validators";
    import generateId from "@/utils/generateNodeSecret";

    export default {
        name: "OpenVpnNodeForm",
        props: { node: { type: Object, required: true } },
        methods: {
            generateSecret() {
                this.node.secret =  generateId(64);
            }
        },
        validations: {
            node: {
                ip: {required},
                server_address: {required},
                port: {required},
                settings: {required},
                provider: {required},
                preshared_secret: {required}
            }
        }
    };
</script>

<style scoped lang="scss">
    .form-row {
      display: flex;
      justify-content: space-between;

      div {
        width: 65%;

        & + div {
          width: 30%;
        }
      }
    }

    .gen-key {
      cursor: pointer !important;

      &:active {
        position: relative;
        top: 2px;
      }
    }

    .md-field > .md-icon:after {
      display: none !important;
    }

    .error-feedback {
      font-size: 12px;
      color: red;
    }
</style>
